import React from "react";
import { NavBar } from '../components/navBar'
import { Link } from "react-router-dom";
const NotFound = ({ location }) => (
  <>
     <NavBar />
    <p>Sorry! Could not find the page {location.pathname}</p>
    <h2>Need some help? Click below to get back to your profile</h2>
    <Link to="/profile">CLICK ME</Link>
  </>
);
export const NotFoundScreen = NotFound;